import { NextPageWithLayout } from 'next';
import React, { ReactElement } from 'react';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { useIntl } from 'react-intl';
import markdown from '../data/staticPages/fashion-united-media.md';
import Layout from '../components/Layout';
import messages from '../lib/messages.json';
import HomeLink from '../components/HomeLink';
import Head from '../components/Head';
import LinkAndAnchor from '../components/LinkAndAnchor';
import Markdown from '../components/Markdown';

const FashionUnitedMediaPage: NextPageWithLayout = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="fashion-united-media"
      passHref
    >
      {intl.formatMessage(messages['info.features.media'])}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages['info.features.media'])}
        description={intl.formatMessage(messages['info.features.media'])}
      />
      <StaticPageComponent
        content={<Markdown markdown={markdown} />}
        title={intl.formatMessage(messages['info.features.media'])}
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};

FashionUnitedMediaPage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

export default FashionUnitedMediaPage;
